import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

const Sales = (props) => {
  const [visibleSales, setVisibleSales] = useState(false);

  const [formValues, setFormValues] = useState({
    SaleIDPrefix: "",
    ItemIDToShowOnSalesInterface: "",
    HideSupplierOnSalesInterface: false,
    HideSupplierOnReceivingsInterface: false,
    AllowReorderOnSaleScreen: false,
    AllowReorderOnReceivingScreen: false,
    DisableEntireFixedDiscountsOnSalesInterface: false,
    DisableEntireDiscountsByPercentageOnSalesInterface: false,
    DisableSaleCloning: false,
    AlwaysPutLastAddedItemOnTopOfCart: false,
    DisableReceivingCloning: false,
    ChooseQuantityAfterAddingItemInSales: false,
    ChooseQuantityAfterAddingItemInReceivings: false,
    DamagedReasons: "",
    EnableTips: false,
    TipPresetAmountOf0: false,
    AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces: false,
    CaptureInternalNotesDuringSale: false,
    CaptureSignatureForAllSales: false,
    NumberOfRecentSalesByCustomerToShow: "",
    HideRecentSalesForCustomer: false,
    EnableCustomerQuickAdd: false,
    EnableSupplierQuickAdd: false,
    CollapseSalesInterfaceByDefault: false,
    CollapseReceivingInterfaceByDefault: false,
    DisableConfirmationForCompleteSale: false,
    DisableConfirmationForCompleteReceiving: false,
    DisableSaleQuickComplete: false,
    CalculateAverageCostPriceFromReceivings: false,
    AveragingMethod: "",
    UpdateBaseCostFromUnitQuantityVariations: false,
    UpdateCostPriceOnTransfer: false,
    RequireSupplierForReceiving: false,
    TrackShippingCostForReceivings: false,
    HideSuspendedReceivingsInReports: false,
    TrackCashInRegister: false,
    AmountOfCashToBeLeftInDrawerAtClosing: "",
    AlertWhenCashIsAbove: "",
    AlertWhenCashIsBelow: "",
    TrackChecksInRegister: false,
    TrackGiftcardsInRegister: false,
    TrackDebitCardsInRegister: false,
    TrackCreditCardsInRegister: false,
    DoNotShowExpectedClosingAmountWhenClosingRegister: false,
    HideAvailableGiftCardsInSalesRegister: false,
    ShowGiftCardsEvenIfZeroBalance: false,
    DisableGiftcardDetection: false,
    AlwaysShowItemGrid: false,
    HideImagesInGrid: false,
    EnableQuickSelectInItemGridForVariations: false,
    HideOutOfStockItemsInGrid: false,
    DefaultTypeForGrid: "",
    RequireCustomerForSale: false,
    SelectSalesPersonDuringSale: false,
    DefaultSalesPerson: "",
    CommissionDefaultRate: "",
    CommissionPercentCalculationMethod: "",
    DisableSaleNotifications: false,
    ConfirmErrorMessagesUsingModalDialogs: false,
    ChangeSaleDateForNewSale: false,
    DoNOTGroupItemsThatAreTheSame: false,
    DoNOTAllowItemsToBeSoldBelowCostPrice: false,
    DoNotAllowOutOfStockItemsToBeSold: false,
    DoNotAllowItemsToBeOutOfStockWhenTransferring: false,
    DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation: false,
    EditItemPriceIf0AfterAddingToSale: false,
    RemindEmployeeToOpenCustomerFacingDisplay: false,
    DoNOTAllowSalesWithZeroValue: false,
    PromptAmountForCashSale: false,
    ShowQRCodeOnSaleReceipt: false,
    QRCodeFormat: "",
    DisableVerificationForQRCodes: false,
    HideTagsOnSalesGrid: false,
    HideSuppliersOnSalesGrid: false,
    HideFavoritesOnSalesGrid: false,
    NumberOfDecimalsDisplayedOnSalesInterface: "",
    DoNotAllowEditOfOverallSubtotal: false,
    DisableSupplierSelectionOnSalesInterface: false,
  });
  const [comingSales, setcomingSales] = useState(props.visibleSalesChange);

  const [loading, setLoading] = useState(false);
  const [
    calculateAverageCostPriceFromReceivings,
    setCalculateAverageCostPriceFromReceivings,
  ] = useState(false);

  const token = localStorage.getItem("Token");

  const handleCalculateAverageCostPriceFromReceivings = () => {
    setCalculateAverageCostPriceFromReceivings(
      !calculateAverageCostPriceFromReceivings
    );
  };

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "SaleIDPrefix", AppConfigvalue: values.SaleIDPrefix },
      {
        AppConfigkey: "ItemIDToShowOnSalesInterface",
        AppConfigvalue: values.ItemIDToShowOnSalesInterface,
      },
      {
        AppConfigkey: "HideSupplierOnSalesInterface",
        AppConfigvalue: values.HideSupplierOnSalesInterface,
      },
      {
        AppConfigkey: "HideSupplierOnReceivingsInterface",
        AppConfigvalue: values.HideSupplierOnReceivingsInterface,
      },
      {
        AppConfigkey: "AllowReorderOnSaleScreen",
        AppConfigvalue: values.AllowReorderOnSaleScreen,
      },
      {
        AppConfigkey: "AllowReorderOnReceivingScreen",
        AppConfigvalue: values.AllowReorderOnReceivingScreen,
      },
      {
        AppConfigkey: "DisableEntireFixedDiscountsOnSalesInterface",
        AppConfigvalue: values.DisableEntireFixedDiscountsOnSalesInterface,
      },
      {
        AppConfigkey: "DisableEntireDiscountsByPercentageOnSalesInterface",
        AppConfigvalue:
          values.DisableEntireDiscountsByPercentageOnSalesInterface,
      },
      {
        AppConfigkey: "DisableSaleCloning",
        AppConfigvalue: values.DisableSaleCloning,
      },
      {
        AppConfigkey: "AlwaysPutLastAddedItemOnTopOfCart",
        AppConfigvalue: values.AlwaysPutLastAddedItemOnTopOfCart,
      },
      {
        AppConfigkey: "DisableReceivingCloning",
        AppConfigvalue: values.DisableReceivingCloning,
      },
      {
        AppConfigkey: "ChooseQuantityAfterAddingItemInSales",
        AppConfigvalue: values.ChooseQuantityAfterAddingItemInSales,
      },
      {
        AppConfigkey: "ChooseQuantityAfterAddingItemInReceivings",
        AppConfigvalue: values.ChooseQuantityAfterAddingItemInReceivings,
      },
      { AppConfigkey: "DamagedReasons", AppConfigvalue: values.DamagedReasons },
      { AppConfigkey: "EnableTips", AppConfigvalue: values.EnableTips },
      {
        AppConfigkey: "TipPresetAmountOf0",
        AppConfigvalue: values.TipPresetAmountOf0,
      },
      {
        AppConfigkey: "AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces",
        AppConfigvalue:
          values.AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces,
      },
      {
        AppConfigkey: "CaptureInternalNotesDuringSale",
        AppConfigvalue: values.CaptureInternalNotesDuringSale,
      },
      {
        AppConfigkey: "CaptureSignatureForAllSales",
        AppConfigvalue: values.CaptureSignatureForAllSales,
      },
      {
        AppConfigkey: "NumberOfRecentSalesByCustomerToShow",
        AppConfigvalue: values.NumberOfRecentSalesByCustomerToShow,
      },
      {
        AppConfigkey: "HideRecentSalesForCustomer",
        AppConfigvalue: values.HideRecentSalesForCustomer,
      },
      {
        AppConfigkey: "EnableCustomerQuickAdd",
        AppConfigvalue: values.EnableCustomerQuickAdd,
      },
      {
        AppConfigkey: "EnableSupplierQuickAdd",
        AppConfigvalue: values.EnableSupplierQuickAdd,
      },
      {
        AppConfigkey: "CollapseSalesInterfaceByDefault",
        AppConfigvalue: values.CollapseSalesInterfaceByDefault,
      },
      {
        AppConfigkey: "CollapseReceivingInterfaceByDefault",
        AppConfigvalue: values.CollapseReceivingInterfaceByDefault,
      },
      {
        AppConfigkey: "DisableConfirmationForCompleteSale",
        AppConfigvalue: values.DisableConfirmationForCompleteSale,
      },
      {
        AppConfigkey: "DisableConfirmationForCompleteReceiving",
        AppConfigvalue: values.DisableConfirmationForCompleteReceiving,
      },
      {
        AppConfigkey: "DisableSaleQuickComplete",
        AppConfigvalue: values.DisableSaleQuickComplete,
      },
      {
        AppConfigkey: "CalculateAverageCostPriceFromReceivings",
        AppConfigvalue: values.CalculateAverageCostPriceFromReceivings,
      },
      {
        AppConfigkey: "AveragingMethod",
        AppConfigvalue: values.AveragingMethod,
      },
      {
        AppConfigkey: "UpdateBaseCostFromUnitQuantityVariations",
        AppConfigvalue: values.UpdateBaseCostFromUnitQuantityVariations,
      },
      {
        AppConfigkey: "UpdateCostPriceOnTransfer",
        AppConfigvalue: values.UpdateCostPriceOnTransfer,
      },
      {
        AppConfigkey: "RequireSupplierForReceiving",
        AppConfigvalue: values.RequireSupplierForReceiving,
      },
      {
        AppConfigkey: "TrackShippingCostForReceivings",
        AppConfigvalue: values.TrackShippingCostForReceivings,
      },
      {
        AppConfigkey: "HideSuspendedReceivingsInReports",
        AppConfigvalue: values.HideSuspendedReceivingsInReports,
      },
      {
        AppConfigkey: "TrackCashInRegister",
        AppConfigvalue: values.TrackCashInRegister,
      },
      {
        AppConfigkey: "AmountOfCashToBeLeftInDrawerAtClosing",
        AppConfigvalue: values.AmountOfCashToBeLeftInDrawerAtClosing,
      },
      {
        AppConfigkey: "AlertWhenCashIsAbove",
        AppConfigvalue: values.AlertWhenCashIsAbove,
      },
      {
        AppConfigkey: "AlertWhenCashIsBelow",
        AppConfigvalue: values.AlertWhenCashIsBelow,
      },
      {
        AppConfigkey: "TrackChecksInRegister",
        AppConfigvalue: values.TrackChecksInRegister,
      },
      {
        AppConfigkey: "TrackGiftcardsInRegister",
        AppConfigvalue: values.TrackGiftcardsInRegister,
      },
      {
        AppConfigkey: "TrackDebitCardsInRegister",
        AppConfigvalue: values.TrackDebitCardsInRegister,
      },
      {
        AppConfigkey: "TrackCreditCardsInRegister",
        AppConfigvalue: values.TrackCreditCardsInRegister,
      },
      {
        AppConfigkey: "DoNotShowExpectedClosingAmountWhenClosingRegister",
        AppConfigvalue:
          values.DoNotShowExpectedClosingAmountWhenClosingRegister,
      },
      {
        AppConfigkey: "HideAvailableGiftCardsInSalesRegister",
        AppConfigvalue: values.HideAvailableGiftCardsInSalesRegister,
      },
      {
        AppConfigkey: "ShowGiftCardsEvenIfZeroBalance",
        AppConfigvalue: values.ShowGiftCardsEvenIfZeroBalance,
      },
      {
        AppConfigkey: "DisableGiftcardDetection",
        AppConfigvalue: values.DisableGiftcardDetection,
      },
      {
        AppConfigkey: "AlwaysShowItemGrid",
        AppConfigvalue: values.AlwaysShowItemGrid,
      },
      {
        AppConfigkey: "HideImagesInGrid",
        AppConfigvalue: values.HideImagesInGrid,
      },
      {
        AppConfigkey: "EnableQuickSelectInItemGridForVariations",
        AppConfigvalue: values.EnableQuickSelectInItemGridForVariations,
      },
      {
        AppConfigkey: "HideOutOfStockItemsInGrid",
        AppConfigvalue: values.HideOutOfStockItemsInGrid,
      },
      {
        AppConfigkey: "DefaultTypeForGrid",
        AppConfigvalue: values.DefaultTypeForGrid,
      },
      {
        AppConfigkey: "RequireCustomerForSale",
        AppConfigvalue: values.RequireCustomerForSale,
      },
      {
        AppConfigkey: "SelectSalesPersonDuringSale",
        AppConfigvalue: values.SelectSalesPersonDuringSale,
      },
      {
        AppConfigkey: "DefaultSalesPerson",
        AppConfigvalue: values.DefaultSalesPerson,
      },
      {
        AppConfigkey: "CommissionDefaultRate",
        AppConfigvalue: values.CommissionDefaultRate,
      },
      {
        AppConfigkey: "CommissionPercentCalculationMethod",
        AppConfigvalue: values.CommissionPercentCalculationMethod,
      },
      {
        AppConfigkey: "DisableSaleNotifications",
        AppConfigvalue: values.DisableSaleNotifications,
      },
      {
        AppConfigkey: "ConfirmErrorMessagesUsingModalDialogs",
        AppConfigvalue: values.ConfirmErrorMessagesUsingModalDialogs,
      },
      {
        AppConfigkey: "ChangeSaleDateForNewSale",
        AppConfigvalue: values.ChangeSaleDateForNewSale,
      },
      {
        AppConfigkey: "DoNOTGroupItemsThatAreTheSame",
        AppConfigvalue: values.DoNOTGroupItemsThatAreTheSame,
      },
      {
        AppConfigkey: "DoNOTAllowItemsToBeSoldBelowCostPrice",
        AppConfigvalue: values.DoNOTAllowItemsToBeSoldBelowCostPrice,
      },
      {
        AppConfigkey: "DoNotAllowOutOfStockItemsToBeSold",
        AppConfigvalue: values.DoNotAllowOutOfStockItemsToBeSold,
      },
      {
        AppConfigkey: "DoNotAllowItemsToBeOutOfStockWhenTransferring",
        AppConfigvalue: values.DoNotAllowItemsToBeOutOfStockWhenTransferring,
      },
      {
        AppConfigkey:
          "DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation",
        AppConfigvalue:
          values.DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation,
      },
      {
        AppConfigkey: "EditItemPriceIf0AfterAddingToSale",
        AppConfigvalue: values.EditItemPriceIf0AfterAddingToSale,
      },
      {
        AppConfigkey: "RemindEmployeeToOpenCustomerFacingDisplay",
        AppConfigvalue: values.RemindEmployeeToOpenCustomerFacingDisplay,
      },
      {
        AppConfigkey: "DoNOTAllowSalesWithZeroValue",
        AppConfigvalue: values.DoNOTAllowSalesWithZeroValue,
      },
      {
        AppConfigkey: "PromptAmountForCashSale",
        AppConfigvalue: values.PromptAmountForCashSale,
      },
      {
        AppConfigkey: "ShowQRCodeOnSaleReceipt",
        AppConfigvalue: values.ShowQRCodeOnSaleReceipt,
      },
      { AppConfigkey: "QRCodeFormat", AppConfigvalue: values.QRCodeFormat },
      {
        AppConfigkey: "DisableVerificationForQRCodes",
        AppConfigvalue: values.DisableVerificationForQRCodes,
      },
      {
        AppConfigkey: "HideTagsOnSalesGrid",
        AppConfigvalue: values.HideTagsOnSalesGrid,
      },
      {
        AppConfigkey: "HideSuppliersOnSalesGrid",
        AppConfigvalue: values.HideSuppliersOnSalesGrid,
      },
      {
        AppConfigkey: "HideFavoritesOnSalesGrid",
        AppConfigvalue: values.HideFavoritesOnSalesGrid,
      },
      {
        AppConfigkey: "NumberOfDecimalsDisplayedOnSalesInterface",
        AppConfigvalue: values.NumberOfDecimalsDisplayedOnSalesInterface,
      },
      {
        AppConfigkey: "DoNotAllowEditOfOverallSubtotal",
        AppConfigvalue: values.DoNotAllowEditOfOverallSubtotal,
      },
      {
        AppConfigkey: "DisableSupplierSelectionOnSalesInterface",
        AppConfigvalue: values.DisableSupplierSelectionOnSalesInterface,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "SALES",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=SALES`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "SaleIDPrefix") {
            formValues.SaleIDPrefix = data.AppConfigvalue;
          } else if (data.AppConfigkey === "ItemIDToShowOnSalesInterface") {
            formValues.ItemIDToShowOnSalesInterface = data.AppConfigvalue;
          } else if (data.AppConfigkey === "HideSupplierOnSalesInterface") {
            formValues.HideSupplierOnSalesInterface =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "HideSupplierOnReceivingsInterface"
          ) {
            formValues.HideSupplierOnReceivingsInterface =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AllowReorderOnSaleScreen") {
            formValues.AllowReorderOnSaleScreen =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AllowReorderOnReceivingScreen") {
            formValues.AllowReorderOnReceivingScreen =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DisableEntireFixedDiscountsOnSalesInterface"
          ) {
            formValues.DisableEntireFixedDiscountsOnSalesInterface =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "DisableEntireDiscountsByPercentageOnSalesInterface"
          ) {
            formValues.DisableEntireDiscountsByPercentageOnSalesInterface =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DisableSaleCloning") {
            formValues.DisableSaleCloning =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "AlwaysPutLastAddedItemOnTopOfCart"
          ) {
            formValues.AlwaysPutLastAddedItemOnTopOfCart =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DisableReceivingCloning") {
            formValues.DisableReceivingCloning =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "ChooseQuantityAfterAddingItemInSales"
          ) {
            formValues.ChooseQuantityAfterAddingItemInSales =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "ChooseQuantityAfterAddingItemInReceivings"
          ) {
            formValues.ChooseQuantityAfterAddingItemInReceivings =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DamagedReasons") {
            formValues.DamagedReasons = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EnableTips") {
            formValues.EnableTips =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TipPresetAmountOf0") {
            formValues.TipPresetAmountOf0 =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
          ) {
            formValues.AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "CaptureInternalNotesDuringSale") {
            formValues.CaptureInternalNotesDuringSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "CaptureSignatureForAllSales") {
            formValues.CaptureSignatureForAllSales =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "NumberOfRecentSalesByCustomerToShow"
          ) {
            formValues.NumberOfRecentSalesByCustomerToShow =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "HideRecentSalesForCustomer") {
            formValues.HideRecentSalesForCustomer =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableCustomerQuickAdd") {
            formValues.EnableCustomerQuickAdd =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableSupplierQuickAdd") {
            formValues.EnableSupplierQuickAdd =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "CollapseSalesInterfaceByDefault") {
            formValues.CollapseSalesInterfaceByDefault =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "CollapseReceivingInterfaceByDefault"
          ) {
            formValues.CollapseReceivingInterfaceByDefault =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DisableConfirmationForCompleteSale"
          ) {
            formValues.DisableConfirmationForCompleteSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DisableConfirmationForCompleteReceiving"
          ) {
            formValues.DisableConfirmationForCompleteReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DisableSaleQuickComplete") {
            formValues.DisableSaleQuickComplete =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "CalculateAverageCostPriceFromReceivings"
          ) {
            formValues.CalculateAverageCostPriceFromReceivings =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AveragingMethod") {
            formValues.AveragingMethod = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "UpdateBaseCostFromUnitQuantityVariations"
          ) {
            formValues.UpdateBaseCostFromUnitQuantityVariations =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "UpdateCostPriceOnTransfer") {
            formValues.UpdateCostPriceOnTransfer =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "RequireSupplierForReceiving") {
            formValues.RequireSupplierForReceiving =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TrackShippingCostForReceivings") {
            formValues.TrackShippingCostForReceivings =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideSuspendedReceivingsInReports") {
            formValues.HideSuspendedReceivingsInReports =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TrackCashInRegister") {
            formValues.TrackCashInRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "AmountOfCashToBeLeftInDrawerAtClosing"
          ) {
            formValues.AmountOfCashToBeLeftInDrawerAtClosing =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "AlertWhenCashIsAbove") {
            formValues.AlertWhenCashIsAbove = data.AppConfigvalue;
          } else if (data.AppConfigkey === "AlertWhenCashIsBelow") {
            formValues.AlertWhenCashIsBelow =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TrackChecksInRegister") {
            formValues.TrackChecksInRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TrackGiftcardsInRegister") {
            formValues.TrackGiftcardsInRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TrackDebitCardsInRegister") {
            formValues.TrackDebitCardsInRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "TrackCreditCardsInRegister") {
            formValues.TrackCreditCardsInRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "DoNotShowExpectedClosingAmountWhenClosingRegister"
          ) {
            formValues.DoNotShowExpectedClosingAmountWhenClosingRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "HideAvailableGiftCardsInSalesRegister"
          ) {
            formValues.HideAvailableGiftCardsInSalesRegister =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowGiftCardsEvenIfZeroBalance") {
            formValues.ShowGiftCardsEvenIfZeroBalance =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DisableGiftcardDetection") {
            formValues.DisableGiftcardDetection =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AlwaysShowItemGrid") {
            formValues.AlwaysShowItemGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideImagesInGrid") {
            formValues.HideImagesInGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "EnableQuickSelectInItemGridForVariations"
          ) {
            formValues.EnableQuickSelectInItemGridForVariations =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideOutOfStockItemsInGrid") {
            formValues.HideOutOfStockItemsInGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DefaultTypeForGrid") {
            formValues.DefaultTypeForGrid = data.AppConfigvalue;
          } else if (data.AppConfigkey === "RequireCustomerForSale") {
            formValues.RequireCustomerForSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "SelectSalesPersonDuringSale") {
            formValues.SelectSalesPersonDuringSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DefaultSalesPerson") {
            formValues.DefaultSalesPerson = data.AppConfigvalue;
          } else if (data.AppConfigkey === "CommissionDefaultRate") {
            formValues.CommissionDefaultRate = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "CommissionPercentCalculationMethod"
          ) {
            formValues.CommissionPercentCalculationMethod = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DisableSaleNotifications") {
            formValues.DisableSaleNotifications =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "ConfirmErrorMessagesUsingModalDialogs"
          ) {
            formValues.ConfirmErrorMessagesUsingModalDialogs =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ChangeSaleDateForNewSale") {
            formValues.ChangeSaleDateForNewSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DoNOTGroupItemsThatAreTheSame") {
            formValues.DoNOTGroupItemsThatAreTheSame =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DoNOTAllowItemsToBeSoldBelowCostPrice"
          ) {
            formValues.DoNOTAllowItemsToBeSoldBelowCostPrice =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DoNotAllowOutOfStockItemsToBeSold"
          ) {
            formValues.DoNotAllowOutOfStockItemsToBeSold =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "DoNotAllowItemsToBeOutOfStockWhenTransferring"
          ) {
            formValues.DoNotAllowItemsToBeOutOfStockWhenTransferring =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
          ) {
            formValues.DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "EditItemPriceIf0AfterAddingToSale"
          ) {
            formValues.EditItemPriceIf0AfterAddingToSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "RemindEmployeeToOpenCustomerFacingDisplay"
          ) {
            formValues.RemindEmployeeToOpenCustomerFacingDisplay =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DoNOTAllowSalesWithZeroValue") {
            formValues.DoNOTAllowSalesWithZeroValue =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "PromptAmountForCashSale") {
            formValues.PromptAmountForCashSale =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowQRCodeOnSaleReceipt") {
            formValues.ShowQRCodeOnSaleReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "QRCodeFormat") {
            formValues.QRCodeFormat = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DisableVerificationForQRCodes") {
            formValues.DisableVerificationForQRCodes =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideTagsOnSalesGrid") {
            formValues.HideTagsOnSalesGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideSuppliersOnSalesGrid") {
            formValues.HideSuppliersOnSalesGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideFavoritesOnSalesGrid") {
            formValues.HideFavoritesOnSalesGrid =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "NumberOfDecimalsDisplayedOnSalesInterface"
          ) {
            formValues.NumberOfDecimalsDisplayedOnSalesInterface =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "DoNotAllowEditOfOverallSubtotal") {
            formValues.DoNotAllowEditOfOverallSubtotal =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DisableSupplierSelectionOnSalesInterface"
          ) {
            formValues.DisableSupplierSelectionOnSalesInterface =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const data = [
    {
      name: "Sale ID Prefix:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="SaleIDPrefix"
              name="SaleIDPrefix"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Item ID To Show On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="ItemIDToShowOnSalesInterface"
              name="ItemIDToShowOnSalesInterface"
              onChange={handleChange}
            >
              <option>UPC/EAN/ISBN</option>
              <option>Product ID</option>
              <option>Item ID</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Item ID To Show On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="ItemIDToShowOnSalesInterface"
              name="ItemIDToShowOnSalesInterface"
              onChange={handleChange}
            >
              <option>UPC/EAN/ISBN</option>
              <option>Product ID</option>
              <option>Item ID</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Hide Supplier On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideSupplierOnSalesInterface"
              name="HideSupplierOnSalesInterface"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Allow Reorder On Sale Screen:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AllowReorderOnSaleScreen"
              name="AllowReorderOnSaleScreen"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Entire Fixed Discounts On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableEntireFixedDiscountsOnSalesInterface"
              name="DisableEntireFixedDiscountsOnSalesInterface"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Entire Discounts By Percentage On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableEntireDiscountsByPercentageOnSalesInterface"
              name="DisableEntireDiscountsByPercentageOnSalesInterface"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Sale Cloning:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableSaleCloning"
              name="DisableSaleCloning"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Always Put Last Added Item On Top Of Cart:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AlwaysPutLastAddedItemOnTopOfCart"
              name="AlwaysPutLastAddedItemOnTopOfCart"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Receiving Cloning:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableReceivingCloning"
              name="DisableReceivingCloning"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Choose Quantity After Adding Item In Sales:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ChooseQuantityAfterAddingItemInSales"
              name="ChooseQuantityAfterAddingItemInSales"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Choose Quantity After Adding Item In Receivings:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ChooseQuantityAfterAddingItemInReceivings"
              name="ChooseQuantityAfterAddingItemInReceivings"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Damaged Reasons:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="DamagedReasons"
              name="DamagedReasons"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Enable Tips:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnableTips"
              name="EnableTips"
              onChange={handleChange}
            />
          </div>
          <p>Not all processors support integrated tip processing</p>
        </>
      ),
    },
    {
      name: "Tip Preset Amount Of 0%:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TipPresetAmountOf0"
              name="TipPresetAmountOf0"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Auto Focus On Item Field When Using Sales/Receivings Interfaces:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
              name="AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Capture Internal Notes During Sale:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="CaptureInternalNotesDuringSale"
              name="CaptureInternalNotesDuringSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Capture Signature For All Sales:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="CaptureSignatureForAllSales"
              name="CaptureSignatureForAllSales"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Number Of Recent Sales By Customer To Show:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="NumberOfRecentSalesByCustomerToShow"
              name="NumberOfRecentSalesByCustomerToShow"
              onChange={handleChange}
            >
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
              <option>200</option>
              <option>500</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Hide Recent Sales For Customer:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideRecentSalesForCustomer"
              name="HideRecentSalesForCustomer"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Enable Customer Quick Add:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnableCustomerQuickAdd"
              name="EnableCustomerQuickAdd"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Enable Supplier Quick Add:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnableSupplierQuickAdd"
              name="EnableSupplierQuickAdd"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Collapse Sales Interface By Default:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="CollapseSalesInterfaceByDefault"
              name="CollapseSalesInterfaceByDefault"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Collapse Receiving Interface By Default:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="CollapseReceivingInterfaceByDefault"
              name="CollapseReceivingInterfaceByDefault"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Confirmation For Complete Sale:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableConfirmationForCompleteSale"
              name="DisableConfirmationForCompleteSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Confirmation For Complete Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableConfirmationForCompleteReceiving"
              name="DisableConfirmationForCompleteReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Sale Quick Complete:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableSaleQuickComplete"
              name="DisableSaleQuickComplete"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Calculate Average Cost Price From Receivings:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="CalculateAverageCostPriceFromReceivings"
              name="CalculateAverageCostPriceFromReceivings"
              onChange={handleChange}
              onInput={handleCalculateAverageCostPriceFromReceivings}
            />
          </div>
        </>
      ),
    },
    {
      name: "calculateAverageCostPriceFromReceivings",
      input: (
        <>
          <div
            className={`form-group row ${
              calculateAverageCostPriceFromReceivings === true ? "" : "d-none"
            }`}
          >
            <label className="col-form-label col-lg-2 ">
              Averaging Method:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  as="select"
                  className="form-control form-small select"
                  id="AveragingMethod"
                  name="AveragingMethod"
                  onChange={handleChange}
                >
                  <option>Moving Average</option>
                  <option>Historical Average</option>
                  <option>Don't average, use current received price</option>
                </Field>
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Update Base Cost From Unit Quantity Variations:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="UpdateBaseCostFromUnitQuantityVariations"
              name="UpdateBaseCostFromUnitQuantityVariations"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Require Supplier For Receiving:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RequireSupplierForReceiving"
              name="RequireSupplierForReceiving"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Track Shipping Cost For Receivings:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TrackShippingCostForReceivings"
              name="TrackShippingCostForReceivings"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Suspended Receivings In Reports:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideSuspendedReceivingsInReports"
              name="HideSuspendedReceivingsInReports"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Track Cash In Register:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TrackCashInRegister"
              name="TrackCashInRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Amount Of Cash To Be Left In Drawer At Closing:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="AmountOfCashToBeLeftInDrawerAtClosing"
              name="AmountOfCashToBeLeftInDrawerAtClosing"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Alert When Cash Is Above:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="AlertWhenCashIsAbove"
              name="AlertWhenCashIsAbove"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Alert When Cash Is Below:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control"
              id="AlertWhenCashIsBelow"
              name="AlertWhenCashIsBelow"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Track Checks In Register:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TrackChecksInRegister"
              name="TrackChecksInRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Track Giftcards In Register:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TrackGiftcardsInRegister"
              name="TrackGiftcardsInRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Track Debit Cards In Register:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TrackDebitCardsInRegister"
              name="TrackDebitCardsInRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Track Credit Cards In Register:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="TrackCreditCardsInRegister"
              name="TrackCreditCardsInRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Do Not Show Expected Closing Amount When Closing Register:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNotShowExpectedClosingAmountWhenClosingRegister"
              name="DoNotShowExpectedClosingAmountWhenClosingRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Available Gift Cards In Sales Register:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideAvailableGiftCardsInSalesRegister"
              name="HideAvailableGiftCardsInSalesRegister"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show Gift Cards Even If Zero Balance:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowGiftCardsEvenIfZeroBalance"
              name="ShowGiftCardsEvenIfZeroBalance"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Giftcard Detection:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableGiftcardDetection"
              name="DisableGiftcardDetection"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Always Show Item Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="AlwaysShowItemGrid"
              name="AlwaysShowItemGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Enable Quick Select In Item Grid For Variations:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnableQuickSelectInItemGridForVariations"
              name="EnableQuickSelectInItemGridForVariations"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Out Of Stock Items In Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideOutOfStockItemsInGrid"
              name="HideOutOfStockItemsInGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Default Type For Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="DefaultTypeForGrid"
              name="DefaultTypeForGrid"
              onChange={handleChange}
            >
              <option>Categories</option>
              <option>Tags</option>
              <option>Suppliers</option>
              <option>Favorites</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Require Customer For Sale:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RequireCustomerForSale"
              name="RequireCustomerForSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Select Sales Person During Sale:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="SelectSalesPersonDuringSale"
              name="SelectSalesPersonDuringSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Default Sales Person:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="DefaultSalesPerson"
              name="DefaultSalesPerson"
              onChange={handleChange}
            >
              <option>Logged in employee</option>
              <option>Not set</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Commission Default Rate:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control h-auto"
              id="CommissionDefaultRate"
              name="CommissionDefaultRate"
              onChange={handleChange}
            />
            <span className="input-group-text" id="basic-addon1">
              %
            </span>
          </div>
        </>
      ),
    },
    {
      name: "Commission Percent Calculation Method:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="CommissionPercentCalculationMethod"
              name="CommissionPercentCalculationMethod"
              onChange={handleChange}
            >
              <option>Selling Price</option>
              <option>Profit</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Disable Sale Notifications:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableSaleNotifications"
              name="DisableSaleNotifications"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Confirm Error Messages Using Modal Dialogs:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ConfirmErrorMessagesUsingModalDialogs"
              name="ConfirmErrorMessagesUsingModalDialogs"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Change Sale Date For New Sale:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ChangeSaleDateForNewSale"
              name="ChangeSaleDateForNewSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Do NOT Group Items That Are The Same:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNOTGroupItemsThatAreTheSame"
              name="DoNOTGroupItemsThatAreTheSame"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Do NOT Allow Items To Be Sold Below Cost Price:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNOTAllowItemsToBeSoldBelowCostPrice"
              name="DoNOTAllowItemsToBeSoldBelowCostPrice"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Do Not Allow Out Of Stock Items To Be Sold:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNotAllowOutOfStockItemsToBeSold"
              name="DoNotAllowOutOfStockItemsToBeSold"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Do NOT Allow Variation Items To Be Sold Without Selecting Variation:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
              name="DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Edit Item Price If 0 After Adding To Sale:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EditItemPriceIf0AfterAddingToSale"
              name="EditItemPriceIf0AfterAddingToSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Remind Employee To Open Customer Facing Display:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="RemindEmployeeToOpenCustomerFacingDisplay"
              name="RemindEmployeeToOpenCustomerFacingDisplay"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Do NOT Allow Sales With Zero Value:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNOTAllowSalesWithZeroValue"
              name="DoNOTAllowSalesWithZeroValue"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Prompt Amount For Cash Sale:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="PromptAmountForCashSale"
              name="PromptAmountForCashSale"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Show QR Code On Sale Receipt:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowQRCodeOnSaleReceipt"
              name="ShowQRCodeOnSaleReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "QR Code Format:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="QRCodeFormat"
              name="QRCodeFormat"
              onChange={handleChange}
            >
              <option>Link To Receipt</option>
              <option>Sale Summary Info</option>
              <option>Saudi Arabia Digital Receipt</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Disable Verification For QR Codes (Do Not Require A Phone Number Or Email):",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableVerificationForQRCodes"
              name="DisableVerificationForQRCodes"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Tags On Sales Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideTagsOnSalesGrid"
              name="HideTagsOnSalesGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Suppliers On Sales Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideSuppliersOnSalesGrid"
              name="HideSuppliersOnSalesGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Hide Favorites On Sales Grid:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="HideFavoritesOnSalesGrid"
              name="HideFavoritesOnSalesGrid"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Number Of Decimals Displayed On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-small select"
              id="NumberOfDecimalsDisplayedOnSalesInterface"
              name="NumberOfDecimalsDisplayedOnSalesInterface"
              onChange={handleChange}
            >
              <option>Let system decide (Recommended)</option>
              <option>0</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Do Not Allow Edit Of Overall Subtotal:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DoNotAllowEditOfOverallSubtotal"
              name="DoNotAllowEditOfOverallSubtotal"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Disable Supplier Selection On Sales Interface:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="DisableSupplierSelectionOnSalesInterface"
              name="DisableSupplierSelectionOnSalesInterface"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "",
      input: <></>,
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleSales(!visibleSales);
                  setcomingSales(!!comingSales);
                }}
              >
                Sales
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleSales || props.visibleSalesChange}>
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {() => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        width: "73%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div style={{ width: "53%" }}>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Item ID To Show On Sales Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="ItemIDToShowOnSalesInterface"
                          name="ItemIDToShowOnSalesInterface"
                          onChange={handleChange}
                        >
                          <option>UPC/EAN/ISBN</option>
                          <option>Product ID</option>
                          <option>Item ID</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Supplier On Sales Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSupplierOnSalesInterface"
                          name="HideSupplierOnSalesInterface"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Supplier On Receivings Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSupplierOnReceivingsInterface"
                          name="HideSupplierOnReceivingsInterface"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Allow Reorder On Sale Screen:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AllowReorderOnSaleScreen"
                          name="AllowReorderOnSaleScreen"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Allow Reorder On Receiving Screen:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AllowReorderOnReceivingScreen"
                          name="AllowReorderOnReceivingScreen"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Entire Fixed Discounts On Sales Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableEntireFixedDiscountsOnSalesInterface"
                          name="DisableEntireFixedDiscountsOnSalesInterface"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Entire Discounts By Percentage On Sales Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableEntireDiscountsByPercentageOnSalesInterface"
                          name="DisableEntireDiscountsByPercentageOnSalesInterface"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Sale Cloning:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableSaleCloning"
                          name="DisableSaleCloning"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Always Put Last Added Item On Top Of Cart:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AlwaysPutLastAddedItemOnTopOfCart"
                          name="AlwaysPutLastAddedItemOnTopOfCart"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Receiving Cloning:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableReceivingCloning"
                          name="DisableReceivingCloning"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Choose Quantity After Adding Item In Sales:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ChooseQuantityAfterAddingItemInSales"
                          name="ChooseQuantityAfterAddingItemInSales"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Choose Quantity After Adding Item In Receivings:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ChooseQuantityAfterAddingItemInReceivings"
                          name="ChooseQuantityAfterAddingItemInReceivings"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Damaged Reasons:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DamagedReasons"
                          name="DamagedReasons"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Tips:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableTips"
                          name="EnableTips"
                          onChange={handleChange}
                        />
                      </div>
                      <p>
                        Not all processors support integrated tip processing
                      </p>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Tip Preset Amount Of 0%:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TipPresetAmountOf0"
                          name="TipPresetAmountOf0"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Auto Focus On Item Field When Using Sales/Receivings
                      Interfaces:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
                          name="AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Capture Internal Notes During Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="CaptureInternalNotesDuringSale"
                          name="CaptureInternalNotesDuringSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Capture Signature For All Sales:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="CaptureSignatureForAllSales"
                          name="CaptureSignatureForAllSales"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Recent Sales By Customer To Show:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfRecentSalesByCustomerToShow"
                          name="NumberOfRecentSalesByCustomerToShow"
                          onChange={handleChange}
                        >
                          <option>10</option>
                          <option>20</option>
                          <option>50</option>
                          <option>100</option>
                          <option>200</option>
                          <option>500</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Recent Sales For Customer:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideRecentSalesForCustomer"
                          name="HideRecentSalesForCustomer"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Customer Quick Add:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableCustomerQuickAdd"
                          name="EnableCustomerQuickAdd"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Supplier Quick Add:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableSupplierQuickAdd"
                          name="EnableSupplierQuickAdd"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Collapse Sales Interface By Default:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="CollapseSalesInterfaceByDefault"
                          name="CollapseSalesInterfaceByDefault"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Collapse Receiving Interface By Default:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="CollapseReceivingInterfaceByDefault"
                          name="CollapseReceivingInterfaceByDefault"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Confirmation For Complete Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableConfirmationForCompleteSale"
                          name="DisableConfirmationForCompleteSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Confirmation For Complete Receiving:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableConfirmationForCompleteReceiving"
                          name="DisableConfirmationForCompleteReceiving"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Sale Quick Complete:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableSaleQuickComplete"
                          name="DisableSaleQuickComplete"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Calculate Average Cost Price From Receivings:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="CalculateAverageCostPriceFromReceivings"
                          name="CalculateAverageCostPriceFromReceivings"
                          onChange={handleChange}
                          onInput={
                            handleCalculateAverageCostPriceFromReceivings
                          }
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div
                    className={`form-group row ${
                      calculateAverageCostPriceFromReceivings === true
                        ? ""
                        : "d-none"
                    }`}
                  >
                    <label className="col-form-label col-lg-2 ">
                      Averaging Method:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="AveragingMethod"
                          name="AveragingMethod"
                          onChange={handleChange}
                        >
                          <option>Moving Average</option>
                          <option>Historical Average</option>
                          <option>
                            Don't average, use current received price
                          </option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Update Base Cost From Unit Quantity Variations:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="UpdateBaseCostFromUnitQuantityVariations"
                          name="UpdateBaseCostFromUnitQuantityVariations"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    <div
                      className={`form-group row ${
                        calculateAverageCostPriceFromReceivings === true
                          ? ""
                          : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2 ">
                        Update Cost Price On Transfer:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="UpdateCostPriceOnTransfer"
                            name="UpdateCostPriceOnTransfer"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Require Supplier For Receiving:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="RequireSupplierForReceiving"
                          name="RequireSupplierForReceiving"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Track Shipping Cost For Receivings:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TrackShippingCostForReceivings"
                          name="TrackShippingCostForReceivings"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Suspended Receivings In Reports:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSuspendedReceivingsInReports"
                          name="HideSuspendedReceivingsInReports"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Track Cash In Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TrackCashInRegister"
                          name="TrackCashInRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Amount Of Cash To Be Left In Drawer At Closing:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="AmountOfCashToBeLeftInDrawerAtClosing"
                          name="AmountOfCashToBeLeftInDrawerAtClosing"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Alert When Cash Is Above:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="AlertWhenCashIsAbove"
                          name="AlertWhenCashIsAbove"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Alert When Cash Is Below:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="AlertWhenCashIsBelow"
                          name="AlertWhenCashIsBelow"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Track Checks In Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TrackChecksInRegister"
                          name="TrackChecksInRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Track Giftcards In Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TrackGiftcardsInRegister"
                          name="TrackGiftcardsInRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Track Debit Cards In Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TrackDebitCardsInRegister"
                          name="TrackDebitCardsInRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Track Credit Cards In Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="TrackCreditCardsInRegister"
                          name="TrackCreditCardsInRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do Not Show Expected Closing Amount When Closing Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNotShowExpectedClosingAmountWhenClosingRegister"
                          name="DoNotShowExpectedClosingAmountWhenClosingRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Available Gift Cards In Sales Register:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideAvailableGiftCardsInSalesRegister"
                          name="HideAvailableGiftCardsInSalesRegister"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Gift Cards Even If Zero Balance:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowGiftCardsEvenIfZeroBalance"
                          name="ShowGiftCardsEvenIfZeroBalance"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Giftcard Detection:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableGiftcardDetection"
                          name="DisableGiftcardDetection"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Always Show Item Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AlwaysShowItemGrid"
                          name="AlwaysShowItemGrid"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Images In Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideImagesInGrid"
                          name="HideImagesInGrid"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Select In Item Grid For Variations:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickSelectInItemGridForVariations"
                          name="EnableQuickSelectInItemGridForVariations"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Out Of Stock Items In Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideOutOfStockItemsInGrid"
                          name="HideOutOfStockItemsInGrid"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Type For Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DefaultTypeForGrid"
                          name="DefaultTypeForGrid"
                          onChange={handleChange}
                        >
                          <option>Categories</option>
                          <option>Tags</option>
                          <option>Suppliers</option>
                          <option>Favorites</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Require Customer For Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="RequireCustomerForSale"
                          name="RequireCustomerForSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Select Sales Person During Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="SelectSalesPersonDuringSale"
                          name="SelectSalesPersonDuringSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Sales Person:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DefaultSalesPerson"
                          name="DefaultSalesPerson"
                          onChange={handleChange}
                        >
                          <option>Logged in employee</option>
                          <option>Not set</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Commission Default Rate:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CommissionDefaultRate"
                          name="CommissionDefaultRate"
                          onChange={handleChange}
                        />
                        <span className="input-group-text" id="basic-addon1">
                          %
                        </span>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Commission Percent Calculation Method:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="CommissionPercentCalculationMethod"
                          name="CommissionPercentCalculationMethod"
                          onChange={handleChange}
                        >
                          <option>Selling Price</option>
                          <option>Profit</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Sale Notifications:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableSaleNotifications"
                          name="DisableSaleNotifications"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Confirm Error Messages Using Modal Dialogs:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ConfirmErrorMessagesUsingModalDialogs"
                          name="ConfirmErrorMessagesUsingModalDialogs"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Change Sale Date For New Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ChangeSaleDateForNewSale"
                          name="ChangeSaleDateForNewSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Group Items That Are The Same:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTGroupItemsThatAreTheSame"
                          name="DoNOTGroupItemsThatAreTheSame"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Allow Items To Be Sold Below Cost Price:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTAllowItemsToBeSoldBelowCostPrice"
                          name="DoNOTAllowItemsToBeSoldBelowCostPrice"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do Not Allow Out Of Stock Items To Be Sold:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNotAllowOutOfStockItemsToBeSold"
                          name="DoNotAllowOutOfStockItemsToBeSold"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do Not Allow Items To Be Out Of Stock When Transferring:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNotAllowItemsToBeOutOfStockWhenTransferring"
                          name="DoNotAllowItemsToBeOutOfStockWhenTransferring"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Allow Variation Items To Be Sold Without Selecting
                      Variation:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
                          name="DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Edit Item Price If 0 After Adding To Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EditItemPriceIf0AfterAddingToSale"
                          name="EditItemPriceIf0AfterAddingToSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Remind Employee To Open Customer Facing Display:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="RemindEmployeeToOpenCustomerFacingDisplay"
                          name="RemindEmployeeToOpenCustomerFacingDisplay"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Allow Sales With Zero Value:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTAllowSalesWithZeroValue"
                          name="DoNOTAllowSalesWithZeroValue"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Prompt Amount For Cash Sale:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="PromptAmountForCashSale"
                          name="PromptAmountForCashSale"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show QR Code On Sale Receipt:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowQRCodeOnSaleReceipt"
                          name="ShowQRCodeOnSaleReceipt"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      QR Code Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="QRCodeFormat"
                          name="QRCodeFormat"
                          onChange={handleChange}
                        >
                          <option>Link To Receipt</option>
                          <option>Sale Summary Info</option>
                          <option>Saudi Arabia Digital Receipt</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Verification For QR Codes (Do Not Require A Phone
                      Number Or Email):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableVerificationForQRCodes"
                          name="DisableVerificationForQRCodes"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Tags On Sales Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideTagsOnSalesGrid"
                          name="HideTagsOnSalesGrid"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Suppliers On Sales Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSuppliersOnSalesGrid"
                          name="HideSuppliersOnSalesGrid"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Favorites On Sales Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideFavoritesOnSalesGrid"
                          name="HideFavoritesOnSalesGrid"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Decimals Displayed On Sales Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfDecimalsDisplayedOnSalesInterface"
                          name="NumberOfDecimalsDisplayedOnSalesInterface"
                          onChange={handleChange}
                        >
                          <option>Let system decide (Recommended)</option>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do Not Allow Edit Of Overall Subtotal:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNotAllowEditOfOverallSubtotal"
                          name="DoNotAllowEditOfOverallSubtotal"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Supplier Selection On Sales Interface:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableSupplierSelectionOnSalesInterface"
                          name="DisableSupplierSelectionOnSalesInterface"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleSales(!visibleSales);
                    setcomingSales(!!comingSales);
                  }}
                >
                  Sales
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleSales || props.visibleSalesChange}>
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {() => (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          width: "73%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "60%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Item ID To Show On Sales Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="ItemIDToShowOnSalesInterface"
                           name="ItemIDToShowOnSalesInterface"
                           onChange={handleChange}
                         >
                           <option>UPC/EAN/ISBN</option>
                           <option>Product ID</option>
                           <option>Item ID</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Supplier On Sales Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideSupplierOnSalesInterface"
                           name="HideSupplierOnSalesInterface"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Supplier On Receivings Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideSupplierOnReceivingsInterface"
                           name="HideSupplierOnReceivingsInterface"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Allow Reorder On Sale Screen:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="AllowReorderOnSaleScreen"
                           name="AllowReorderOnSaleScreen"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Allow Reorder On Receiving Screen:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="AllowReorderOnReceivingScreen"
                           name="AllowReorderOnReceivingScreen"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Entire Fixed Discounts On Sales Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableEntireFixedDiscountsOnSalesInterface"
                           name="DisableEntireFixedDiscountsOnSalesInterface"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Entire Discounts By Percentage On Sales Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableEntireDiscountsByPercentageOnSalesInterface"
                           name="DisableEntireDiscountsByPercentageOnSalesInterface"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Sale Cloning:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableSaleCloning"
                           name="DisableSaleCloning"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Always Put Last Added Item On Top Of Cart:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="AlwaysPutLastAddedItemOnTopOfCart"
                           name="AlwaysPutLastAddedItemOnTopOfCart"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Receiving Cloning:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableReceivingCloning"
                           name="DisableReceivingCloning"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Choose Quantity After Adding Item In Sales:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="ChooseQuantityAfterAddingItemInSales"
                           name="ChooseQuantityAfterAddingItemInSales"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Choose Quantity After Adding Item In Receivings:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="ChooseQuantityAfterAddingItemInReceivings"
                           name="ChooseQuantityAfterAddingItemInReceivings"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Damaged Reasons:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           type="text"
                           className="form-control"
                           id="DamagedReasons"
                           name="DamagedReasons"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Enable Tips:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="EnableTips"
                           name="EnableTips"
                           onChange={handleChange}
                         />
                       </div>
                       <p>
                         Not all processors support integrated tip processing
                       </p>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Tip Preset Amount Of 0%:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TipPresetAmountOf0"
                           name="TipPresetAmountOf0"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Auto Focus On Item Field When Using Sales/Receivings
                       Interfaces:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
                           name="AutoFocusOnItemFieldWhenUsingSalesReceivingsInterfaces"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Capture Internal Notes During Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="CaptureInternalNotesDuringSale"
                           name="CaptureInternalNotesDuringSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Capture Signature For All Sales:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="CaptureSignatureForAllSales"
                           name="CaptureSignatureForAllSales"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Number Of Recent Sales By Customer To Show:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="NumberOfRecentSalesByCustomerToShow"
                           name="NumberOfRecentSalesByCustomerToShow"
                           onChange={handleChange}
                         >
                           <option>10</option>
                           <option>20</option>
                           <option>50</option>
                           <option>100</option>
                           <option>200</option>
                           <option>500</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Recent Sales For Customer:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideRecentSalesForCustomer"
                           name="HideRecentSalesForCustomer"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Enable Customer Quick Add:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="EnableCustomerQuickAdd"
                           name="EnableCustomerQuickAdd"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Enable Supplier Quick Add:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="EnableSupplierQuickAdd"
                           name="EnableSupplierQuickAdd"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Collapse Sales Interface By Default:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="CollapseSalesInterfaceByDefault"
                           name="CollapseSalesInterfaceByDefault"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Collapse Receiving Interface By Default:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="CollapseReceivingInterfaceByDefault"
                           name="CollapseReceivingInterfaceByDefault"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Confirmation For Complete Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableConfirmationForCompleteSale"
                           name="DisableConfirmationForCompleteSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Confirmation For Complete Receiving:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableConfirmationForCompleteReceiving"
                           name="DisableConfirmationForCompleteReceiving"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Sale Quick Complete:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableSaleQuickComplete"
                           name="DisableSaleQuickComplete"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Calculate Average Cost Price From Receivings:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="CalculateAverageCostPriceFromReceivings"
                           name="CalculateAverageCostPriceFromReceivings"
                           onChange={handleChange}
                           onInput={
                             handleCalculateAverageCostPriceFromReceivings
                           }
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div
                     className={`form-group row ${
                       calculateAverageCostPriceFromReceivings === true
                         ? ""
                         : "d-none"
                     }`}
                   >
                     <label className="col-form-label col-lg-2 ">
                       Averaging Method:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="AveragingMethod"
                           name="AveragingMethod"
                           onChange={handleChange}
                         >
                           <option>Moving Average</option>
                           <option>Historical Average</option>
                           <option>
                             Don't average, use current received price
                           </option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Update Base Cost From Unit Quantity Variations:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="UpdateBaseCostFromUnitQuantityVariations"
                           name="UpdateBaseCostFromUnitQuantityVariations"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      <div
                        className={`form-group row ${
                          calculateAverageCostPriceFromReceivings === true
                            ? ""
                            : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2 ">
                          Update Cost Price On Transfer:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              className="form-check-input"
                              style={{ width: "1.5em", height: "1.5em" }}
                              type="checkbox"
                              id="UpdateCostPriceOnTransfer"
                              name="UpdateCostPriceOnTransfer"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Require Supplier For Receiving:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="RequireSupplierForReceiving"
                           name="RequireSupplierForReceiving"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Track Shipping Cost For Receivings:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TrackShippingCostForReceivings"
                           name="TrackShippingCostForReceivings"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Suspended Receivings In Reports:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideSuspendedReceivingsInReports"
                           name="HideSuspendedReceivingsInReports"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Track Cash In Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TrackCashInRegister"
                           name="TrackCashInRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Amount Of Cash To Be Left In Drawer At Closing:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           type="text"
                           className="form-control"
                           id="AmountOfCashToBeLeftInDrawerAtClosing"
                           name="AmountOfCashToBeLeftInDrawerAtClosing"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Alert When Cash Is Above:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           type="text"
                           className="form-control"
                           id="AlertWhenCashIsAbove"
                           name="AlertWhenCashIsAbove"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Alert When Cash Is Below:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           type="text"
                           className="form-control"
                           id="AlertWhenCashIsBelow"
                           name="AlertWhenCashIsBelow"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Track Checks In Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TrackChecksInRegister"
                           name="TrackChecksInRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Track Giftcards In Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TrackGiftcardsInRegister"
                           name="TrackGiftcardsInRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Track Debit Cards In Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TrackDebitCardsInRegister"
                           name="TrackDebitCardsInRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Track Credit Cards In Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="TrackCreditCardsInRegister"
                           name="TrackCreditCardsInRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do Not Show Expected Closing Amount When Closing Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNotShowExpectedClosingAmountWhenClosingRegister"
                           name="DoNotShowExpectedClosingAmountWhenClosingRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Available Gift Cards In Sales Register:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideAvailableGiftCardsInSalesRegister"
                           name="HideAvailableGiftCardsInSalesRegister"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Show Gift Cards Even If Zero Balance:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="ShowGiftCardsEvenIfZeroBalance"
                           name="ShowGiftCardsEvenIfZeroBalance"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Giftcard Detection:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableGiftcardDetection"
                           name="DisableGiftcardDetection"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Always Show Item Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="AlwaysShowItemGrid"
                           name="AlwaysShowItemGrid"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Images In Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideImagesInGrid"
                           name="HideImagesInGrid"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Enable Quick Select In Item Grid For Variations:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="EnableQuickSelectInItemGridForVariations"
                           name="EnableQuickSelectInItemGridForVariations"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Out Of Stock Items In Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideOutOfStockItemsInGrid"
                           name="HideOutOfStockItemsInGrid"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Default Type For Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="DefaultTypeForGrid"
                           name="DefaultTypeForGrid"
                           onChange={handleChange}
                         >
                           <option>Categories</option>
                           <option>Tags</option>
                           <option>Suppliers</option>
                           <option>Favorites</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Require Customer For Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="RequireCustomerForSale"
                           name="RequireCustomerForSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Select Sales Person During Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="SelectSalesPersonDuringSale"
                           name="SelectSalesPersonDuringSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Default Sales Person:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="DefaultSalesPerson"
                           name="DefaultSalesPerson"
                           onChange={handleChange}
                         >
                           <option>Logged in employee</option>
                           <option>Not set</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Commission Default Rate:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           type="text"
                           className="form-control"
                           id="CommissionDefaultRate"
                           name="CommissionDefaultRate"
                           onChange={handleChange}
                         />
                         <span className="input-group-text" id="basic-addon1">
                           %
                         </span>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Commission Percent Calculation Method:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="CommissionPercentCalculationMethod"
                           name="CommissionPercentCalculationMethod"
                           onChange={handleChange}
                         >
                           <option>Selling Price</option>
                           <option>Profit</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Sale Notifications:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableSaleNotifications"
                           name="DisableSaleNotifications"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Confirm Error Messages Using Modal Dialogs:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="ConfirmErrorMessagesUsingModalDialogs"
                           name="ConfirmErrorMessagesUsingModalDialogs"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Change Sale Date For New Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="ChangeSaleDateForNewSale"
                           name="ChangeSaleDateForNewSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do NOT Group Items That Are The Same:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNOTGroupItemsThatAreTheSame"
                           name="DoNOTGroupItemsThatAreTheSame"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do NOT Allow Items To Be Sold Below Cost Price:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNOTAllowItemsToBeSoldBelowCostPrice"
                           name="DoNOTAllowItemsToBeSoldBelowCostPrice"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do Not Allow Out Of Stock Items To Be Sold:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNotAllowOutOfStockItemsToBeSold"
                           name="DoNotAllowOutOfStockItemsToBeSold"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do Not Allow Items To Be Out Of Stock When Transferring:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNotAllowItemsToBeOutOfStockWhenTransferring"
                           name="DoNotAllowItemsToBeOutOfStockWhenTransferring"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do NOT Allow Variation Items To Be Sold Without Selecting
                       Variation:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
                           name="DoNOTAllowVariationItemsToBeSoldWithoutSelectingVariation"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Edit Item Price If 0 After Adding To Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="EditItemPriceIf0AfterAddingToSale"
                           name="EditItemPriceIf0AfterAddingToSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Remind Employee To Open Customer Facing Display:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="RemindEmployeeToOpenCustomerFacingDisplay"
                           name="RemindEmployeeToOpenCustomerFacingDisplay"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do NOT Allow Sales With Zero Value:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNOTAllowSalesWithZeroValue"
                           name="DoNOTAllowSalesWithZeroValue"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Prompt Amount For Cash Sale:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="PromptAmountForCashSale"
                           name="PromptAmountForCashSale"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Show QR Code On Sale Receipt:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="ShowQRCodeOnSaleReceipt"
                           name="ShowQRCodeOnSaleReceipt"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       QR Code Format:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="QRCodeFormat"
                           name="QRCodeFormat"
                           onChange={handleChange}
                         >
                           <option>Link To Receipt</option>
                           <option>Sale Summary Info</option>
                           <option>Saudi Arabia Digital Receipt</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Verification For QR Codes (Do Not Require A Phone
                       Number Or Email):
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableVerificationForQRCodes"
                           name="DisableVerificationForQRCodes"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Tags On Sales Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideTagsOnSalesGrid"
                           name="HideTagsOnSalesGrid"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Suppliers On Sales Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideSuppliersOnSalesGrid"
                           name="HideSuppliersOnSalesGrid"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Hide Favorites On Sales Grid:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="HideFavoritesOnSalesGrid"
                           name="HideFavoritesOnSalesGrid"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2">
                       Number Of Decimals Displayed On Sales Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           as="select"
                           className="form-control form-small select"
                           id="NumberOfDecimalsDisplayedOnSalesInterface"
                           name="NumberOfDecimalsDisplayedOnSalesInterface"
                           onChange={handleChange}
                         >
                           <option>Let system decide (Recommended)</option>
                           <option>0</option>
                           <option>1</option>
                           <option>2</option>
                           <option>3</option>
                           <option>4</option>
                           <option>5</option>
                           <option>6</option>
                           <option>7</option>
                           <option>8</option>
                           <option>9</option>
                           <option>10</option>
                         </Field>
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Do Not Allow Edit Of Overall Subtotal:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DoNotAllowEditOfOverallSubtotal"
                           name="DoNotAllowEditOfOverallSubtotal"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      {/* <div className="form-group row">
                     <label className="col-form-label col-lg-2 ">
                       Disable Supplier Selection On Sales Interface:
                     </label>
                     <div className="col-lg-10">
                       <div className="input-group">
                         <Field
                           className="form-check-input"
                           style={{ width: "1.5em", height: "1.5em" }}
                           type="checkbox"
                           id="DisableSupplierSelectionOnSalesInterface"
                           name="DisableSupplierSelectionOnSalesInterface"
                           onChange={handleChange}
                         />
                       </div>
                     </div>
                   </div> */}
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default Sales;
